export function getPendingAgreement(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`/v2/trade-data-agreement/review-agreement/${id}`)
}

export function getOptionAgreements(axiosPrivate) {
  return axiosPrivate.get('/v2/trade-data-agreement/options')
}

export function submitAgreement(axiosPrivate, idAgreement, formData) {
  return axiosPrivate.post(`/v2/trade-data-agreement/review-agreement/${idAgreement}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
